import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "Matricial formalism is here exemplified for two cases: a saxophon with 3 side holes and a loudspeaker placed at the input of a vented box. Using the electrical circuit formalism, derive how the input impedance of the saxophone or the vent can be calculated.",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 2,
      rows: 3,
      rowsSize: [1, 3, 2.5],
      colsSize: [1, 3],
      colSpan: {
        "0:0": 2,
      },
      rowSpan: {
        "1:0": 2,
      },
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "Loudspeaker at the input of a vented box",
                  formatter: "html",
                  scrollbars: false,
                  styles: {
                    fontWeight: 800,
                    letterSpacing: "0.25em",
                    textTransform: "uppercase",
                  },
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/01/29/principle/loudspeaker.svg`,
                },
              },
              styles: {
                padding: "2%",
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/01/29/principle/principle-4.svg`,
                },
              },
              styles: {
                padding: "1%",
              },
            },
          },
        ],
        [
          null,
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/01/29/principle/principle-4-solution.svg`,
                  styles: {
                    maxHeight: "157px",
                    maxWidth: "321px",
                  },
                },
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
